
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"17.098","height":"18.364"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"clip-path-ask-for"}},[_c('rect',{attrs:{"id":"Rectangle_8336","data-name":"Rectangle 8336","width":"12.664","height":"12.664","rx":"3","fill":"#4d45ff"}})])]),_c('g',{attrs:{"id":"ask_for","transform":"translate(-104.949 -559.481)"}},[_c('g',{attrs:{"id":"Group_27957","data-name":"Group 27957","transform":"translate(-1449.5 -485.495)"}},[_c('rect',{attrs:{"id":"Rectangle_8335","data-name":"Rectangle 8335","width":"12.664","height":"12.664","rx":"3","transform":"translate(1554.449 1044.977)","fill":"#82e9fd"}}),_c('g',{attrs:{"id":"Group_27782","data-name":"Group 27782"}},[_c('rect',{attrs:{"id":"Rectangle_8332","data-name":"Rectangle 8332","width":"12.664","height":"12.664","rx":"3","transform":"translate(1558.883 1050.676)","fill":"#7c76fa"}}),_c('g',{attrs:{"id":"Mask_Group_231","data-name":"Mask Group 231","transform":"translate(1558.883 1050.676)","clip-path":"url(#clip-path-ask-for)"}},[_c('path',{attrs:{"id":"Path_20601","data-name":"Path 20601","d":"M1.948 0h8.768a2.3 2.3 0 011.948 2.533v7.6a2.3 2.3 0 01-1.948 2.533H1.948A2.3 2.3 0 010 10.131v-7.6A2.3 2.3 0 011.948 0z","transform":"translate(-3.41 -4.433)","fill":"#4d45ff"}})]),_c('g',{attrs:{"id":"Group_27781","data-name":"Group 27781","transform":"translate(1562.801 1054.592)","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-width":"1.5"}},[_c('line',{attrs:{"id":"Line_556","data-name":"Line 556","x2":"4.83","transform":"translate(0 2.414)"}}),_c('line',{attrs:{"id":"Line_562","data-name":"Line 562","x2":"4.83","transform":"rotate(90 1.208 1.208)"}})])])])])])
          )
        }
      }
    